import ProcessList from "./ProcessList";

const ProcessListOngoing = ({ processType }) => {
  return <ProcessList endpoint={"Processes/UsersOngoing/"} processType={processType} process={"ongoing"} />
};

export default ProcessListOngoing;
